const getMessageString = (intl, text) => intl.formatMessage({ id: text, defaultMessage: text });

export { getMessageString };
